// Cache utilities to handle localStorage issues
export const clearAllCache = () => {
  try {
    // Clear localStorage
    localStorage.clear();
    
    // Clear sessionStorage
    sessionStorage.clear();
    
    // Try to clear any Service Worker caches if they exist
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => {
          caches.delete(name);
        });
      });
    }
    
    console.log('All cache cleared successfully');
    return true;
  } catch (error) {
    console.error('Error clearing cache:', error);
    return false;
  }
};

export const clearAuthCache = () => {
  try {
    // Clear regular auth data
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    
    // Clear superuser auth data
    localStorage.removeItem('superuser_token');
    localStorage.removeItem('superuser');
    
    console.log('Auth cache cleared successfully');
    return true;
  } catch (error) {
    console.error('Error clearing auth cache:', error);
    return false;
  }
};

// Function to validate localStorage data before using
export const isValidJSON = (str) => {
  if (!str || typeof str !== 'string' || str.length < 2) {
    return false;
  }
  
  try {
    const parsed = JSON.parse(str);
    return parsed && typeof parsed === 'object';
  } catch {
    return false;
  }
};